import NotificationPage from 'components/global/NotificationPage/NotificationPage';

const VCNotifications = () => <NotificationPage />;

export default VCNotifications;
